import React from "react";
import "./styles/main.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import WebsiteRoutes from "./pages/website/routes";
import AdminRoutes from "./pages/admin/routes";
import AppRoutes from "./pages/app/routes";
import UnauthorizedPage from "./pages/common/UnauthorizedPage";
import AnalyticsListener from "./components/analytics/AnalyticsListener";

const App: React.FC = () => (
  <HelmetProvider>
    <BrowserRouter>
      <AnalyticsListener />
      <Routes>
        {/* Website public pages */}
        <Route path="/*" element={<WebsiteRoutes />} />

        {/* Admin routes */}
        <Route path="/admin/*" element={<AdminRoutes />} />

        {/* App routes */}
        <Route path="/app/*" element={<AppRoutes />} />

        <Route path="/unauthorized" element={<UnauthorizedPage />} />
      </Routes>
    </BrowserRouter>
  </HelmetProvider>
);

export default App;
